import CookieBasedAuthUserService from 'core/auth/CookieBasedAuthUserService';
import Http from 'core/http/HttpService';

class UserService
    extends CookieBasedAuthUserService {
  ping() {
    if (!this.configured) {
      throw Error('UserService is not configured');
    }

    return Http.get({
      url: this.config.ping.url
    });
  }
}

const service = new UserService();

export default service;
